import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export const createContactSchedule = function (data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
        query: `
            mutation {
                createContactSchedule (
                    instance_id: ${data.instance_id},
                    customer_id: ${data.customer_id},
                    user_id: ${data.user_id},
                    date_send: "${data.date_send}",
                    time_send: "${data.time_send}",
                    text_message: """${data.text_message.replace(/"/g, `'`)}""",
                    message_template_name: "${data.message_template_name}",
                    message_template_id: "${data.message_template_id}",
                    official_params: [${data.official_params.map(data => {return `"${data}"`}).join(',')}] 
                ) {
                    id,
                    instance_id,
                    customer_id,
                    user_id,
                    customer {
                        id,
                        name,
                        phone_number
                    },
                    instance {
                        id,
                        name,
                        phone_number
                    },
                    user {
                        id,
                        name
                    },
                    triggering_date,
                    date_send,
                    time_send,
                    text_message,
                    is_sent,
                    message_template_name,
                    message_template_id
                }
            }
        `
    })
}

export const fetchAll = function (sortName = 'triggering_date', sortType = 'ASC') {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
        query: `
            query {
                contactSchedule (
                    is_cancelled_at: null,
                    with: ["customer", "user", "instance"],
                    orderBy: ["${sortName}", "${sortType}"]
                ) {
                    id,
                    instance_id,
                    customer_id,
                    user_id,
                    customer {
                        id,
                        name,
                        phone_number
                    },
                    instance {
                        id,
                        name,
                        waba_id,
                        is_official,
                        phone_number
                    },
                    user {
                        id,
                        name
                    },
                    triggering_date,
                    date_send,
                    time_send,
                    text_message,
                    is_sent,
                    message_template_name,
                    message_template_id
                }
            }
        `
    })
}

export const updateContactSchedule = function (data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
        query: `
            mutation {
                updateContactSchedule (
                    id: ${data.targetId},
                    triggering_date: "${data.triggering_date}",
                    text_message: """${data.text_message.replace(/"/g, `'`)}""",
                    message_template_name: "${data.message_template_name}",
                    message_template_id: "${data.message_template_id}",
                    official_params: [${data.official_params.map(data => {return `"${data}"`}).join(',')}] 
                ) {
                    id,
                    instance_id,
                    customer_id,
                    user_id,
                    customer {
                        id,
                        name,
                        phone_number
                    },
                    instance {
                        id,
                        name,
                        phone_number
                    },
                    user {
                        id,
                        name
                    },
                    triggering_date,
                    date_send,
                    time_send,
                    text_message,
                    is_sent
                }
            }
        `
    })
}

export const deleteContactSchedule = function (data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
        query: `
            mutation {
                deleteContactSchedule (
                    id: ${data.targetId}
                )
            }
        `
    })
}
